import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Link } from "@material-ui/icons";
import React from "react";
import { TileProps } from "../../../services/core/types";
import { userRendererStyles } from "./useRendererStyles";

export const CountTile: React.FC<TileProps> = ({ tile, navigate }) => {
  const classes = userRendererStyles();

  const getColorClass = (
    lowerLimit: number,
    upperLimit: number,
    value: number
  ) => {
    if (value <= lowerLimit) {
      return classes.green;
    }
    if (value > lowerLimit && value < upperLimit) {
      return classes.amber;
    }
    if (value >= upperLimit) {
      return classes.red;
    }
  };

  return (
    <Grid item xs={12} xl={2} lg={3} md={4}>
      <Card className={classes.root}>
        <CardHeader
          action={
            <Tooltip title={`View list of ${tile.title}`}>
              <IconButton onClick={() => navigate && navigate(tile.filterUrl)}>
                <Link />
              </IconButton>
            </Tooltip>
          }
          title={
            <Typography variant="body1" className={classes.cardHeading}>
              {tile.title}
            </Typography>
          }
          className={classes.header}
        />
        <Divider />
        <CardContent className={classes.cardContent}>
          <Grid container>
            {tile.parsedData.map((data, index) => {
              return (
                <Grid item xs={4} key={index}>
                  <div className={classes.container}>
                    <Tooltip title={`View list ${data.title}`}>
                      <IconButton
                        onClick={() =>
                          navigate &&
                          navigate(
                            `${tile.filterUrl}&DashboardParam=${data.key}`
                          )
                        }
                      >
                        <Avatar
                          className={`${classes.countAvatar} ${getColorClass(
                            tile.lowerLimit || 0,
                            tile.upperLimit || 10,
                            data.value
                          )}`}
                        >
                          {data.value}
                        </Avatar>
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div className={classes.container}>
                    <Typography
                      variant="body2"
                      className={classes.countCaption}
                    >
                      {data.title}
                    </Typography>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
